import { FC } from 'react';

import { FEED_LAYOUT } from '@constants';
import { Box, BrowserFrame, Grid, Masonry, Vertical } from '@versumstudios/ui';

interface IBrowserPreview {
  layout?: FEED_LAYOUT;
  info?: boolean;
  market?: boolean;
  labels?: boolean;
}

export const BrowserPreview: FC<IBrowserPreview> = ({ layout, info, market, labels }) => {
  const renderType = () => {
    switch (layout) {
      case FEED_LAYOUT.MASONRY:
        return <Masonry info={info} market={market} labels={labels} />;
      case FEED_LAYOUT.GRID:
        return <Grid info={info} market={market} labels={labels} />;
      default:
        return <Vertical info={info} market={market} labels={labels} />;
    }
  };

  return (
    <Box css={{ width: '100%', backgroundColor: '$secondaryBackground' }} horizontal>
      <Box css={{ marginTop: 32, height: 150, overflow: 'hidden' }}>
        <BrowserFrame>{renderType()}</BrowserFrame>
      </Box>
    </Box>
  );
};
